import { render, staticRenderFns } from "./vme-iframe.html?vue&type=template&id=ebf1c1fc&scoped=true&"
import script from "./vme-iframe.ts?vue&type=script&lang=ts&"
export * from "./vme-iframe.ts?vue&type=script&lang=ts&"
import style0 from "./vme-iframe.scss?vue&type=style&index=0&id=ebf1c1fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebf1c1fc",
  null
  
)

/* custom blocks */
import block0 from "./vme-iframe.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fviews%2Fhome%2Fvme-iframe%2Fvme-iframe.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCol,VContainer,VRow})
